import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from '../../theme/constants';
import { FlexContainer } from '@emarketer/componentlibrary';

export const HomeContainerWrapper = styled(FlexContainer)`
  background-color: ${COLOR.WHITE};
  width: 100%;
  min-height: 100vh;
`;

export const AdBottomWrapper = styled(FlexContainer)`
  width: 100%;
  flex-grow: 1;
  padding-bottom: 30px;
`;

export const IndexWrapper = styled(FlexContainer)`
  margin: 0 auto;
  width: 100%;
`;

export const ForecastsHeaderWrapper = styled.div`
  padding: 60px 0px;
  @media only screen and (max-width: 1200px) {
    padding: 60px 20px;
  }
  box-sizing: border-box;
`;

export const NewsletterSignupForm = styled.div`
  display: none;

  @media (min-width: 1200px) {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    padding-bottom: 50px;
  }
`;

export const ForecastsContainer = styled.div`
  background-color: ${COLOR.GRAY50};
  width: 100%;
`;

export const ForecastsIntro = styled.div`
  max-width: 1028px;
  margin: 0 auto;
  padding-bottom: 38px;
`;

export const TabWrapper = styled.div<{ isMobile?: boolean }>`
  max-width: 1028px;
  width: 100%;
  margin: -${(p) => (p.isMobile ? 30 : 25)}px auto 0;
  padding: 0 ${(p) => (p.isMobile ? 0 : 20)}px;
`;

export const ForecastsTitle = styled.div`
  ${TYPOGRAPHY.BOLD};
  font-size: 32px;
`;

export const ForecastsSubtitle = styled.div`
  color: ${COLOR.DARKGREY2};
  font-size: 16px;
  padding-bottom: 40px;
`;

export const ForecastsFilters = styled.div``;
